import axios from "axios";
import { API_ASSET, API_DEVICE, API_TRENDS } from "../../../commons/api";
import localStorage from "../../../utils/localStorage";

export async function getAssetList ()  {
    const accessToken = localStorage.get("accessToken");
    const siteId = localStorage.get("currentSite");
    let orgHeaders = {
      method: "GET",
      url: `${API_ASSET.CLIENT_GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return axios(orgHeaders)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  
  export async function getDeviceList ()  {
    const accessToken = localStorage.get("accessToken");
    const siteId = localStorage.get("currentSite");
    let orgHeaders = {
      method: "GET",
      url: `${API_DEVICE.GETDevices}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return axios(orgHeaders)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

 export async function getParametersList(payload) {
   const siteId = localStorage.get('currentSite');
   const token = localStorage.get('accessToken');
   const Authorization = 'Bearer ' + token;
 
     let orgHeaders = {
       method: 'POST',
       url:`${API_TRENDS.GetParameters}?SiteId=${siteId}`,
       headers: {
         Authorization: Authorization,
         'Content-Type': 'application/json'
       },
      data:payload
     };
   return axios(orgHeaders)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
 }